<template>
  <div id="Course"
       class="Course">
    <div class="Course_cont">
      <div class="gl_title_bar">
        <div class="gl_tb_left">
          <span :class="{ normaltitlenew_active: couhead === 0 }"
                class="normaltitlenew"
                @click="getCourseList(1, 0, 1)">购买课程</span>
          <span v-if="userType != 0"
                class="xiegang">/</span>
          <span :class="{ normaltitlenew_active: couhead === 1 }"
                v-if="userType != 0"
                class="normaltitlenew"
                @click="getCourseList(4, 1, 1)">VIP课程</span>
          <span v-if="this.doct == 1"
                class="xiegang">/</span>
          <span :class="{ normaltitlenew_active: couhead === 3 }"
                class="normaltitlenew"
                @click="getCourseList(3, 3, 1)">兑换课程</span>
        </div>
      </div>
      <!-- 购买课程 -->
      <div>
        <div v-show="couhead == 0"
             v-if="CourseList.length == 0"
             class="NoneData">
          <p>
            <i class="iconfont icon-wushujutanhao"></i>
            <span>暂无相关数据</span>
          </p>
        </div>

        <div v-else
             class="display_between marginTop20"
             style="display:flex;justify-content: flex-start;"
             v-show="couhead == 0"
             v-for="(item, index) in CourseList"
             :key="index + '1'">
          <div class="pub_square"
               v-for="(itemn, indexn) in item"
               :key="indexn"
               style="margin-right:20px"
               @click.stop="TomenuPlayVid(itemn)">
            <div class="pubs_img">
              <img class="pubs_img"
                   :src="itemn.coverPicture" />
            </div>
            <div class="pubs_body">
              <div class="coursepustitle"
                   :title="itemn.title">
                {{ ellipsis(itemn.title, 14) }}
              </div>
              <div class="pubs_progess">
                <div class="pubs_progess_active"
                     :style="{ width: Math.ceil(itemn.learning * 100).toFixed(2) + '%' }">
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span>已学</span>
                  <span class="normalColor">{{ Math.ceil(itemn.learning * 100).toFixed(0) + '%' }}</span>
                </div>
                <div class="pubs_date">
                  {{ itemn.createTime }}
                  <img src="/image/geren/del.png"
                       @click.stop="DelCourseTab(itemn)"
                       v-if="item.claTyapify != 1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- VIP课程 -->
      <div>
        <div v-show="couhead == 1"
             v-if="CourseVipList.length == 0"
             class="NoneData">
          <p>
            <i class="iconfont icon-wushujutanhao"></i>
            <span>暂无相关数据</span>
          </p>
        </div>

        <div v-else
             class="display_between marginTop20"
             style="display:flex;justify-content: flex-start;"
             v-show="couhead == 1"
             v-for="(item, index) in CourseVipList"
             :key="index + '2'">
          <div class="pub_square"
               v-for="(itemn, indexn) in item"
               @click.stop="TomenuPlayVid(itemn)"
               style="margin-right:20px"
               :key="indexn">
            <div class="pubs_img">
              <img class="pubs_img"
                   :src="itemn.coverPicture" />
            </div>
            <div class="pubs_body">
              <div class="coursepustitle"
                   :title="itemn.title">
                {{ ellipsis(itemn.title, 14) }}
              </div>
              <div class="pubs_progess">
                <div class="pubs_progess_active"
                     :style="{ width: Math.ceil(itemn.learning * 100).toFixed(0) + '%' }">
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span>已学</span>
                  <span class="normalColor">{{ Math.ceil(itemn.learning * 100).toFixed(0) }}% </span>
                </div>
                <div class="pubs_date">
                  {{ itemn.createTime }}

                  <img src="/image/geren/del.png"
                       @click.stop="DelCourseTab(itemn)"
                       v-if="item.claTyapify != 1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--机构课程-->
      <div>
        <div v-show="couhead == 2"
             v-if="orgBatch.length == 0"
             class="NoneData">
          <p>
            <i class="iconfont icon-wushujutanhao"></i>
            <span>暂无相关数据</span>
          </p>
        </div>

        <div class=" Course_cont_main Course_cont_main_org"
             v-show="couhead == 2">
          <div class="main_org_naviga">
            <ul style="list-style-type:none;padding-left: 0px">
              <li :class="{ orgbatch: orgbatch == index }"
                  v-for="(item, index) in orgBatch"
                  :key="index + '4'"
                  @click="getCoursOrgList(item, index)">
                <p>{{ item.batchName }}</p>
                <p>{{ item.unitName }}</p>
                <i class="iconfont icon-zhuanpanxuanzhong"></i>
              </li>
              <div style="clear:both;"></div>
            </ul>
          </div>
          <br />
          <div class="main_org_contenlist">
            <el-collapse v-model="activeNames">
              <el-collapse-item :title="item.coursePackageName"
                                :name="index"
                                v-for="(item, index) in CourseOrgList"
                                :key="index">
                <ul style="list-style-type:none; padding-left: 0px">
                  <li v-for="(v, index) in item.classSchedResultList"
                      :key="index"
                      @click.stop="TomenuPlayVid(v)">
                    <div class="main_img">
                      <img :src="v.coverPicture"
                           alt="" />
                    </div>
                    <p :title="v.title">{{ v.title }}</p>
                    <el-progress style="height:16px"
                                 :percentage="parseInt(v.learning * 100)"></el-progress>
                    <p class="xuepersb">
                      <span class="fl">已学{{ parseInt(v.learning * 100) }}%</span>
                      <span class="fr">
                        <span>{{ v.createTime }}</span>
                      </span>
                    </p>
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <!-- 兑换课程 -->
      <div>
        <div v-show="couhead == 3"
             v-if="CourseDoctorList.length == 0"
             class="NoneData">
          <p>
            <i class="iconfont icon-wushujutanhao"></i>
            <span>暂无相关数据</span>
          </p>
        </div>
        <div v-else
             class="display_between marginTop20"
             style="display:flex;justify-content: flex-start;"
             v-show="couhead == 3"
             v-for="(item, index) in CourseDoctorList"
             :key="index + '4'">
          <div class="pub_square"
               style="margin-right:20px"
               v-for="(itemn, indexn) in item"
               :key="indexn"
               @click.stop="TomenuPlayVid(itemn)">
            <div class="pubs_img">
              <img class="pubs_img"
                   :src="itemn.coverPicture" />
            </div>
            <div class="pubs_body">
              <div class="coursepustitle"
                   :title="itemn.title">
                {{ ellipsis(itemn.title, 14) }}
              </div>
              <div class="pubs_progess">
                <div class="pubs_progess_active"
                     :style="{ width: Math.ceil(itemn.learning * 100).toFixed(2) + '%' }">
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span>已学</span>
                  <span class="normalColor">{{ Math.ceil(itemn.learning * 100).toFixed(0) + '%' }}</span>
                </div>
                <div class="pubs_date">
                  {{ itemn.createTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination_Wrap">
        <pagination v-if="this.couhead != 2 && page.total > 0"
                    :total="page.total"
                    :limit="page.pageSize"
                    :page="page.currentPage"
                    @page-change="pageChange"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'userMyCourse',
  data () {
    return {
      // 是否充值过vip
      //   IspayVip: true,
      orgbatch: 0,
      // 机构课程分类批
      orgBatch: [
        {
          batchcou: '第一批课程',
          source: '全科医学'
        },
        {
          batchcou: '第二批课程',
          source: '全科医学'
        },
        {
          batchcou: '第三批课程',
          source: '全科医学'
        }
      ],
      activeNames: [0],
      // 判断是否充值过vip
      userType: '',
      // 用户id
      AuthorId: '',
      page: {
        total: 0,
        pageSize: 9,
        currentPage: 1,
        sizes: [5, 10, 15, 20, 25]
      },
      courseId: '',
      courseIndex: '',
      CourHeadNav: [
        { name: '购买课程', id: 1 },
        { name: '机构课程', id: 2 },
        { name: '兑换课程', id: 3 },
        { name: 'VIP课程', id: 4 }
      ],
      couhead: 0,
      // 购买课程
      CourseList: [],
      // 机构课程
      CourseOrgList: [],
      // 兑换课程
      CourseDoctorList: [],
      // VIP课程
      CourseVipList: [],
      // 机构
      Org: '',
      // 医生圈
      doct: ''
    };
  },
  created () {
    // this.getData()
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
      this.userType = localStorage.getItem('userType');
    }
    this.getCourseList(1, 0, 1);
    this.getInfo();
  },
  //   mounted () {
  //     if (localStorage.getItem('userType') == 'null') {
  //       this.IspayVip = false;
  //     } else {
  //       this.IspayVip = true;
  //     }
  //   },
  methods: {
    getData () {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          var usedata = data.userMyCourse.data;
          that.apiData = lodash.chunk(usedata, 3);
        });
    },
    // 获取机构课程批次
    getOrgBatch () {
      this.couhead = 2;
      this.httphelper
        .post('/api/CourseClassApi/GetInstitutionsCourseBatchList', {
          claType: 2,
          authorId: this.AuthorId
        })
        .then(res => {
          this.orgBatch = res.data.data;
          this.orgBatch.sort(function (a, b) {
            return b.batchId - a.batchId;
          });
          this.getCoursOrgList(this.orgBatch[0], 0);
        });
    },
    // 移出课程表
    DelCourseTab (item) {
      this.$confirm('是否移出课程表？移出后,您可在课程详情页面将课程重新加入课程表', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.httphelper
          .post('/api/CourseClassApi/DelClassCourse', {
            authorid: this.AuthorId,
            id: item.id
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: '移除成功',
                type: 'success'
              });
              this.getCourseList(this.courseId, this.courseIndex, this.page.currentPage);
            } else {
              this.$message({
                message: '不可移除',
                type: 'warning'
              });
            }
          });
      });
    },
    // 点击批次获取课程包和课程
    getCoursOrgList (item, index) {
      this.orgbatch = index;
      this.httphelper
        .post('api/CourseClassApi/GetInstitutionsCoursePackageList', {
          authorId: this.AuthorId,
          batch: item.batchId
        })
        .then(res => {
          this.CourseOrgList = res.data.data;
        });
    },
    // 获取个人信息
    getInfo () {
      this.httphelper
        .post('/api/CGpUserApi/GetUserMessage', {
          id: this.AuthorId
        })
        .then(res => {
          this.Org = res.data.data.org;
          this.doct = res.data.data.doct;
        });
    },
    // 获取课程列表
    getCourseList (id, index, val) {
      this.couhead = index;
      this.courseId = id;
      this.courseIndex = index;
      this.page.currentPage = val;
      var _this = this;
      this.httphelper
        .post('/api/CourseClassApi/GetClassSchedPageList', {
          claType: id,
          authorId: this.AuthorId,
          page: val,
          limit: this.page.pageSize
        })
        .then(res => {
          res.data.data.forEach(i => {
            i.createTime = i.createTime.substr(0, 10);
          });
          if (id == 1) {
            // this.CourseList = res.data.data
            _this.CourseList = lodash.chunk(res.data.data, 3);
          } else if (id == 2) {
            _this.CourseOrgList = lodash.chunk(res.data.data, 3);
          } else if (id == 3) {
            _this.CourseDoctorList = lodash.chunk(res.data.data, 3);
          } else if (id == 4) {
            _this.CourseVipList = lodash.chunk(res.data.data, 3);
          }
          _this.page.total = res.data.totalcount;
        });
    },
    // 点击分页
    pageChange (val) {
      this.page.currentPage = val;
      this.getCourseList(this.courseId, this.courseIndex, val);
      let osTop = document.documentElement.scrollTop || document.body.scrollTop;
      let ispeed = Math.floor(-osTop / 1.0);
      document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
      this.isTop = true;
    },
    // 跳转播放页面
    TomenuPlayVid (item) {
      if (localStorage.getItem('ResData')) {
        window.open(this.httphelper.IsDebugCgphome() + '/detail?courseId=' + item.courseId + '&tokenKey=' + this.$cookies.get('token_chinagp'), "_blank")
      } else {
        window.open(this.httphelper.IsDebugCgphome() + '/detail?courseId=' + item.courseId, "_blank")
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main_org_contenlist ::v-deep .el-collapse-item__header {
    font-size: 17px !important;
}

.main_org_contenlist ::v-deep .el-collapse-item__header .is-active {
    color: #409eff;
}

::v-deep .el-pagination {
    position: relative;
    bottom: -57px;
    text-align: center;
}

::v-deep .el-progress {
    margin-top: 10px !important;

    ::v-deep .el-progress__text {
        display: none;
    }

    ::v-deep .el-progress-bar {
        padding-right: 0;
    }

    ::v-deep .el-progress-bar__outer {
        background: #ffaab4;
        background: rgba(255, 170, 180, 0.5);
    }

    ::v-deep .el-progress-bar__inner {
        background: #e00019;
    }
}

::v-deep .el-table th > .cell {
    color: #000000;
    font-size: 16px;
    font-weight: normal;
}

#Course {
    .Course_cont {
        position: relative;
        padding: 26px 12px 16px 12px;

        .Course_cont_head {
            width: 100%;
            height: 50px;
            margin-left: 17px;

            .couhead {
                color: #e00019;
                font-weight: bold;
                border-bottom: 2px solid #e00019;
            }

            li {
                float: left;
                padding: 9px 0;
                margin-right: 56px;
                cursor: pointer;
            }
        }

        .Course_cont_main {
            width: 100%;
            // height: 500px;
            position: relative;

            // margin-top: 20px;
            .NoneData {
                padding: 40px;
                text-align: center;
                color: #999;
                font-size: 18px;
                letter-spacing: 1px;

                i {
                    font-size: 36px;
                    color: #4da9e8;
                    position: relative;
                    top: 7px;
                    margin-right: 7px;
                }
            }

            li {
                width: 234px;
                height: 212px;
                border: 1px solid #ebebeb;
                padding: 5px 6px 10px 7px;
                border-radius: 12px;
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 25px;
                float: left;
                position: relative;

                .main_img {
                    width: 233px;
                    height: 131px;
                    position: relative;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                    .label {
                        display: block;
                        position: absolute;
                        top: 0;
                        width: 42%;
                        height: 2em;
                        color: #ffffff;
                        font-weight: bold;
                        line-height: 28px;
                        text-align: center;
                        float: left;
                        transform: translate(-25%, 25%) rotate(-45deg);
                        // box-shadow: 0 0 5px rgba(0,0,0,.5),inset 0 0 2px #fff;
                        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
                        z-index: 99;
                    }
                }

                .percenent {
                    height: 16px;
                }

                p:nth-child(2) {
                    height: 20px;
                    color: #000000;
                    font-size: 14px;
                    margin-top: 10px;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    line-clamp: 1;
                    -webkit-box-orient: vertical;
                }

                .xuepersb {
                    width: 94%;
                    height: 20px;
                    margin-top: 8px;
                    position: absolute;
                    bottom: 8px;

                    span:nth-child(1) {
                        color: #434343;
                        font-size: 14px;
                    }

                    span:nth-child(2) {
                        i {
                            font-size: 16px;
                            color: #a1a1a1;
                            margin-left: 14px;
                        }
                    }

                    span:nth-child(2):hover {
                        i {
                            color: #e0001a;
                        }
                    }

                    span:nth-child(3) {
                        i {
                            font-size: 18px;
                            color: #a1a1a1;
                        }

                        span {
                            color: #9b9b9b;
                            font-size: 14px;
                            position: relative;
                        }
                    }
                }
            }

            li:hover {
                border: 1px solid #e00019;
            }

            li:nth-child(3n + 3) {
                margin-right: 0;
            }

            .conversion {
                width: 100%;
                border-bottom: 1px dashed #eceef2;
                padding-bottom: 11px;

                .conversion_input {
                    width: 368px;

                    .conversion_dh {
                        display: inline-block;
                        width: 81px;
                        height: 36px;
                        background: #e00019;
                        margin-left: 8px;
                        text-align: center;
                        line-height: 36px;
                        color: #fff;
                        font-size: 16px;
                        cursor: pointer;
                    }
                }

                .exchacode {
                    margin-top: 12px;

                    a {
                        color: #e00019;
                        font-size: 16px;
                        cursor: pointer;
                    }

                    a:hover {
                        text-decoration: underline;
                    }
                }
            }

            .conversion_main {
                width: 100%;
                height: auto;
                margin-top: 22px;

                .fl {
                    width: 98px;
                    height: 58px;
                    margin-top: 5px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .fr {
                    width: 60%;

                    p:nth-child(1) {
                        color: #434343;
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        //autoprefixer: off
                        -webkit-box-orient: vertical;
                        //autoprefixer: on
                        margin-top: 12px;
                    }
                }

                .voitopera {
                    display: inline-block;
                    width: 69px;
                    height: 26px;
                    background: #157eff;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #ffffff;
                    text-align: center;
                    line-height: 26px;
                    cursor: pointer;
                }
            }
        }

        .Course_cont_main:nth-child(3) {
            li {
                // height: 195px;
                p:nth-child(3) {
                    margin-top: 13px;

                    span:nth-child(1) {
                        color: #434343;
                        font-size: 14px;
                    }

                    span:nth-child(2) {
                        i {
                            font-size: 18px;
                            color: #a1a1a1;
                        }

                        span {
                            color: #9b9b9b;
                            font-size: 12px;
                            position: relative;
                            top: -2px;
                        }
                    }
                }
            }
        }

        .Course_cont_main:nth-child(4) {
            .Course_cont_main {
                li {
                    // height: 195px;
                    p:nth-child(3) {
                        margin-top: 13px;

                        span:nth-child(1) {
                            color: #434343;
                            font-size: 14px;
                        }

                        span:nth-child(2) {
                            i {
                                font-size: 18px;
                                color: #a1a1a1;
                            }

                            span {
                                color: #9b9b9b;
                                font-size: 12px;
                                position: relative;
                                top: -2px;
                            }
                        }
                    }
                }
            }
        }

        .NoneData {
            padding: 40px;
            text-align: center;
            color: #999;
            font-size: 18px;
            letter-spacing: 1px;

            i {
                font-size: 36px;
                color: #4da9e8;
                position: relative;
                top: 7px;
                margin-right: 7px;
            }
        }

        .main_cour_cover {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: rgba(000, 000, 000, 0.5);
            text-align: center;
            line-height: 131px;
            color: #fff;
            font-size: 18px;
            letter-spacing: 1px;
        }
    }

    .main_org_naviga {
        width: 100%;

        // height: 130px;
        ul {
            width: 100%;

            .orgbatch {
                // background-image: linear-gradient(left, #5bcdf2, #2f81ed);
                background: linear-gradient(to left, #5bcdf2, #2f81ed);

                p {
                    color: #fff !important;
                }

                p:nth-child(2) {
                    color: #fff !important;
                }

                i {
                    opacity: 0.3;
                }
            }

            li {
                width: 213px !important;
                height: 77px !important;
                margin-right: 3px;
                background: #f8f8f8;
                float: left;
                padding: 34px 16px;
                border: 1px solid #f3f3fe;
                position: relative;

                p:nth-child(1) {
                    color: #000;
                    font-size: 17px;
                    margin-top: 14px;
                    margin-left: 17px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 1;
                    line-clamp: 1;
                    white-space: nowrap;
                }

                p:nth-child(2) {
                    color: #000 !important;
                    font-size: 13px !important;
                    margin-top: 14px;
                    margin-left: 17px;
                }

                i {
                    color: #fff;
                    font-size: 66px;
                    position: absolute;
                    bottom: -36px;
                    right: 6px;
                    opacity: 0;
                }
            }

            li:hover {
                border: 1px solid #409eff !important;
            }
        }
    }

    .main_org_contenlist {
        width: 100%;
        height: auto;
        margin-top: 7px;
    }

    .xiegang {
        font-size: 24px;
        margin: 10px;
        color: #e5e5e5;
    }

    .normaltitlenew {
        font-size: 24px;
        font-weight: bold;
        display: inline-block;
        // border-bottom: 1px solid #333;
        padding-bottom: 14px;
        cursor: pointer;
        margin-right: 10px;
    }

    .normaltitlenew_active {
        border-bottom: 1px solid #333;
        color: #0b8586;
    }

    .coursepustitle {
        width: 237px;
        height: 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
    }
}
</style>
